import useViewport from "../../../hooks/useViewport";
import { StyledCloseButton } from "./styling/Modal.styles";
import { ModalContentProps } from "./Modal.types";

const ModalContent = ({ children, onClose }: ModalContentProps) => {
	const viewport = useViewport();

	return (
		<>
			<StyledCloseButton
				name="close"
				size="md"
				onClick={onClose}
				htmlTag="button"
				viewport={viewport}
			/>
			{children}
		</>
	);
};

export default ModalContent;
